module.exports = __webpack_public_path__ + "static/media/features-recruitment.12bd79cc.png";